export class CriteriaSurveyEmailSenderViewModel
{
    opened: boolean = false;

    surveyId: number | null = null;
    projectUserIds: number[] | null = null;

    show(surveyId: number, projectUserIds: number[])
    {
        this.surveyId = surveyId;
        this.projectUserIds = projectUserIds;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyId = null;
        this.projectUserIds = null;
    }
}